<div class="container" style="min-height: 60vh;">
  <div class="wrapper">
    <h1 class="pageTitle" id="main-content">
      {{ pageTitle }}
    </h1>
    <h2 class="govuk-heading-m">{{ verifyPageText }}</h2>

    @if (paymentFailed) {
      <div class="row pb-4">
        <div class="col-sm-12">
          <p class="govuk-body">We could not verify your payment. Please return to the start and try again.</p>
          <button type="submit" class="btn btn-primary return-button" (click)="restartJourney()">
            Return to homepage
          </button>
        </div>
      </div>
    }
  </div>
</div>
